
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/multi-bot-orchestration",
      function () {
        return require("private-next-pages/docs/multi-bot-orchestration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/multi-bot-orchestration"])
      });
    }
  